import {StyledIconButton} from '@/styles/CommonStyledComponents';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

// ----------------------------------------------------------------------

const StyledRpIcon = styled('i')(({color, size = 20}) => {
  return {
    display: "inline-block",
    width: `${size}px`,
    height: `${size}px`,
    color: color,
    textAlign: 'center',
    fontSize: `${typeof size === "string" ? size : `${size}px`}`,
    lineHeight: `${typeof size === "string" ? size : `${size}px`}`,
  }
})

const IconWrapper = styled(Box)(() => ({
  display: "flex",
  // height: 24,
  // width: 24,
  padding: "4px",
  justifyItems: "center",
  alignItems: "center",
  "& img": {
    width: "100%",
    borderRadius: "50%",
    objectFit: "cover"
  }
}));

export const RpIconColor = {
  MAIN: '#fff',
  SECONDARY: 'rgba(255,255,255,0.6)',
  ERROR: '#E43664',
}

const RpIcon = ({
                  color = "", size = 24, icon, clickable = false, onClick = () => {
  }
                }) => {
  if (!color) {
    color = 'inherit';
  }

  if (!size) {
    size = 24;
  }

  const _getIconEl = () => {
    return <StyledRpIcon color={color} size={size} className={`iconfont icon-${icon}`}></StyledRpIcon>;
  }

  return (<>
    {clickable ? <StyledIconButton sx={{backgroundColor: 'transparent'}} onClick={onClick}>
      <IconWrapper>
        {_getIconEl()}
      </IconWrapper>
    </StyledIconButton> : _getIconEl()}
  </>);
};

export default RpIcon;
